import { container } from '@hydrogen/elements.core.di';
import { useDocuments } from '@hydrogen/elements.data.wealth.rest.use-documents';
import { useAnalysisInvestmentAllocation } from 'services/useAnalysisInvestmentAllocation';
import { useAnalysisPerformance } from '@hydrogen/elements.data.wealth.rest.use-analysis-performance';

container.bind<typeof useDocuments>('useDocuments').toFunction(useDocuments);
container.bind<typeof useAnalysisInvestmentAllocation>('useAnalysisInvestmentAllocation').toFunction(useAnalysisInvestmentAllocation);
container.bind<typeof useAnalysisPerformance>('useAnalysisPerformance').toFunction(useAnalysisPerformance);
